//could merge playerLocal and playerComputer into 1 class with isLocal flag
export default class PlayerComputer {
    constructor(game, level, name) {
        //public
        this.game = game;
        this.level = level;
        this.id;
        this.name = name;
        this.avatar;
        //this.playerPosition = position;
        this.computerTimer;
        this.playCardTimer;
        this.computerDelay = 500;
        this.computerMoveCardSpeed = 500;
        this.isLocal = false;
        this._pullWaitCounter = 0;

        //setup computer
        this.game.showSelection = true;
        if (level === "Local") {
            this.computerDelay = 1200;
            this.computerMoveCardSpeed = 1200;
            this.avatar = 'images/Avatars/Easy.png';
            this.rank = "";
            this.isLocal = true;
        }
        if (level === "Easy") {
            this.computerDelay = 1200;
            this.computerMoveCardSpeed = 1200;
            this.avatar = 'images/Avatars/Easy.png';
            this.rank = "";
        }
        if (level === "Medium") {
            this.computerDelay = 700;
            this.computerMoveCardSpeed = 700;
            this.avatar = 'images/Avatars/Medium.png';
            this.rank = "";
        }
        if (level === "Hard") {
            this.computerDelay = 450;
            this.computerMoveCardSpeed = 450;
            this.avatar = 'images/Avatars/Hard.png';
            this.rank = "";
        }
        if (level === "CrazyNinja") {
            this.computerDelay = 350;
            this.computerMoveCardSpeed = 350;
            this.avatar = 'images/Avatars/CrazyNinja.png';
            this.rank = "";
        }
        if (level === "InsaneMonkey") {
            this.computerDelay = 290;
            this.computerMoveCardSpeed = 290;
            this.avatar = 'images/Avatars/InsaneMonkey.png';
            this.rank = "";
        }
        if (level === "UltraCheetah") {
            this.computerDelay = 150;
            this.computerMoveCardSpeed = 290;
            this.avatar = 'images/Avatars/UltraCheetah.png';
            this.rank = "";
        }
        if (level === "Impossible") {
            this.computerDelay = 60;
            this.computerMoveCardSpeed = 290;
            this.avatar = 'images/Avatars/Impossible.png';
            this.rank = "";
        }
        if (level === "Test") {
            this.computerDelay = 450;
            this.computerMoveCardSpeed = 450;
            this.avatar = 'images/Avatars/default-avatar.png';
        }


    }

    playerPosition() {
        if (this.game.PlayerBottom === this)
            return "Bottom";
        else
            return "Top";
    }



    gameEvent(message, value, location, player) {
        if (message == "loaded") this.loaded();
        if (message == "start") this.startComputer();
        if (message == "pause") this.pause();
        if (message == "resume") this.resume();
        if (message == "dispose") this.dispose();
        if (message == "destroy") this.destroy();
        if (message == "gameover") this.gameover();
        if (message == "pull") {
            this._pullWaitCounter = 2; //wait 2 cycles
        }
    };
    //todo: change to attached computer to game event
    loaded() {
        //one action with a 1 second delay
        clearInterval(this.computerTimerOnce);
        this.computerTimerOnce = setTimeout(() => {
            this.onComputerPlay();
        }, 500);
    }
    start() {
        this.startComputer();
    }

    pause() {
        this.stopComputer();
    }
    resume() {
        this.startComputer();
    }
    destroy() {
        this.stopComputer();
    }

    gameover() {
        this.stopComputer();
    }

    stopComputer() {
        clearInterval(this.computerTimer);
        clearTimeout(this.playCardTimer);
    }
    startComputer(computerName) {
        if (!computerName) computerName = this.level;


        if (computerName === "Local") return;
        if (computerName === "None") return;
        if (computerName === "Online") return;


        clearInterval(this.computerTimer);
        clearTimeout(this.playCardTimer);
        this.computerTimer = setInterval(() => {
            this.onComputerPlay();
        }, this.computerDelay);
    }

    setRandomComputer() {
        var computerNames = ["Larry", "David", "Paul", "Peter", "Jimmy", "John", "Sherry", "Tammy", "Mark", "Heidi", "Luke", "Andy", "Lucy", "Spot"];
        var newComputer = computerNames[Math.floor(Math.random() * computerNames.length)];
        this.level = newComputer;
        this.name = newComputer;
        this.avatar = 'images/Avatars/default-avatar.png';
        switch (newComputer) {
            case "Larry": this.id = -100; this.computerDelay = 290; break;
            case "David": this.id = -101; this.computerDelay = 300; break;
            case "Paul": this.id = -102; this.computerDelay = 320; break;
            case "Peter": this.id = -103; this.computerDelay = 350; break;
            case "Jimmy": this.id = -104; this.computerDelay = 390; break;
            case "John": this.id = -105; this.computerDelay = 410; break;
            case "Sherry": this.id = -106; this.computerDelay = 450; break;
            case "Tammy": this.id = -107; this.computerDelay = 490; break;
            case "Mark": this.id = -108; this.computerDelay = 530; break;
            case "Heidi": this.id = -109; this.computerDelay = 560; break;
            case "Luke": this.id = -110; this.computerDelay = 600; break;
            case "Andy": this.id = -111; this.computerDelay = 650; break;
            case "Lucy": this.id = -112; this.computerDelay = 730; break;
            case "Spot": this.id = -113; this.computerDelay = 800; break;
        }
    }
    onComputerPlay() {
        const game = this.game;
        var playerPosition = this.playerPosition();
        if (!playerPosition) return;

        if (game.state === "GameOver") return;
        if (game.state === "PreGame") {
            game.ready(playerPosition);
        }
        if (game.state === "Playing") {

            playerPosition = playerPosition || "Top";

            var cardsHand = game.getPile("hand2");
            var cardsDraw = game.getPile("draw2");

            if (playerPosition == "Bottom") {
                cardsHand = game.getPile("hand1");
                cardsDraw = game.getPile("draw1");
            }

            //one action per loop
            var computerSelectedCard;

            //sleep after pull card, as to not look like cheating
            //if last even was pull, wait 2-3 cycles
            if (this._pullWaitCounter > 0) {
                this._pullWaitCounter = this._pullWaitCounter - 1;
                return;
            }

            //any card in hand
            if (cardsHand.length > 0) {
                //selectNextcard in hand

                //if dragging wait
                for (var i = 0; i < cardsHand.length; i++) {
                    if (cardsHand[i].dragging === true)
                        return;
                }


                //find current card
                for (var i = 0; i < cardsHand.length; i++) {
                    if (cardsHand[i].selected === true) computerSelectedCard = i;
                }

                //next card
                if (computerSelectedCard === undefined) computerSelectedCard = 0;
                else computerSelectedCard++;

                //select first card
                if (computerSelectedCard >= cardsHand.length)
                    computerSelectedCard = 0;


                //reset selected card
                for (var i = 0; i < cardsHand.length; i++) {
                    cardsHand[i].selected = false;
                }

                //todo: this should be in the speed class
                var selectedCard = cardsHand[computerSelectedCard];

                selectedCard.selected = true;
                game.message("selectedCardChanged", selectedCard);


                var computerMoveCardSpeed = this.computerMoveCardSpeed;//1000;

                //try play card (action)
                if (game.canDrop(selectedCard, "hs1")) {
                    selectedCard.dragging = true;

                    //todo: this should be in the speed class
                    game.message("moveCardToPile", selectedCard.id + ":hs1:" + computerMoveCardSpeed);
                    game.message("startDrag", selectedCard.id, null, "touch");
                    this.playCardTimer = setTimeout(function () {
                        game.tryPlayCard(selectedCard, "hs1");
                        selectedCard.dragging = false;
                    }, computerMoveCardSpeed);
                    return;
                }
                if (game.canDrop(selectedCard, "hs2")) {
                    selectedCard.dragging = true;
                    game.message("moveCardToPile", selectedCard.id + ":hs2:" + computerMoveCardSpeed);
                    this.playCardTimer = setTimeout(function () {
                        game.tryPlayCard(selectedCard, "hs2");
                        selectedCard.dragging = false;
                    }, computerMoveCardSpeed);
                    return;
                }


                //   if (game.tryPlayCard(selectedCard, "hs1") === true) return;
                //  if (game.tryPlayCard(selectedCard, "hs2") === true) return;

            }



            //draw more cards (action)
            if (cardsHand.length < 5 && cardsDraw.length > 0) {
                if (playerPosition === "Top" && game.FillHand2() === true) return;
                if (playerPosition === "Bottom" && game.FillHand1() === true) return;
            }


            //get last card played
            var lastCardPlayed = null;
            for (var i in game.eventLog) {
                if (game.eventLog[i].message === 'cardMoved') lastCardPlayed = game.eventLog[i];
            }

            //try to pull
            if ((lastCardPlayed != null && game.getElaspedTime() - lastCardPlayed.timestamp > 5) || (lastCardPlayed == null && game.getElaspedTime() > 10)) {
                if (game.canPull() === true) {
                    game.pull();
                    return;
                }
            }
        }

    }
}